export var PushSubscriptionState;
(function(PushSubscriptionState) {
    // loading state, e.g. in the middle of subscribing
    PushSubscriptionState[PushSubscriptionState["LOADING"] = 0] = "LOADING";
    // notifications are allowed and there's an active subscription
    PushSubscriptionState[PushSubscriptionState["SUBSCRIBED"] = 1] = "SUBSCRIBED";
    // either need to ask for permission to send notifications
    // and then subscribe,
    // or we have permission but not yet subscribed
    PushSubscriptionState[PushSubscriptionState["READY_TO_SUBSCRIBE"] = 2] = "READY_TO_SUBSCRIBE";
    // user explicitly denied permission, we can neither send
    // notifications nor subscribe
    PushSubscriptionState[PushSubscriptionState["UNABLE_TO_SUBSCRIBE"] = 3] = "UNABLE_TO_SUBSCRIBE";
    // failed to subscribe or other error
    PushSubscriptionState[PushSubscriptionState["FAILED"] = 4] = "FAILED";
})(PushSubscriptionState || (PushSubscriptionState = {}));

//# sourceMappingURL=types.js.map